import React, { Component } from 'react';
import { View, Image, StyleSheet, StatusBar, Keyboard, Linking,
   TouchableOpacity, KeyboardAvoidingView, Platform,  ScrollView, Dimensions, Share, BackHandler, Alert, ImageBackground, TouchableHighlight, 
   PermissionsAndroid, TouchableWithoutFeedback, } from 'react-native';
// import Icon from 'react-native-vector-icons/dist/Ionicons';
// import Icons from 'react-native-vector-icons/FontAwesome';
import AsyncStorage from '@react-native-community/async-storage';
// import Icon from 'react-native-vector-icons/dist/FontAwesome'; 
// import Icon from 'react-native-vector-icons/MaterialIcons';
// import { GoogleSignin, GoogleSigninButton, statusCodes } from 'react-native-google-signin';
import { TextInput, Button, Checkbox, Snackbar,Surface } from 'react-native-paper';
// import Colors from '../Colors';
// import Styles from '../UI/styles';
// import FontIcon from 'react-native-vector-icons/FontAwesome';
// import BackHandlerAndroid from './../AndroidBackHandler';
import { connect } from 'react-redux';
import { login, dispatchClearLoginInfo, } from './../../store/action';
import Toaster from './../../components/snackBar_toaster';
import { Text, Styles} from './../../components/UI-Components';
import BgWrapper from './../../components/bgWrapper';
import BgCircle from './../../components/bgCircle';
import Container from '@material-ui/core/Container';
import zIndex from '@material-ui/core/styles/zIndex';

const { width, height } = Dimensions.get('window');

// import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
// import { deviceHeight, 400, firebaseLogEvent } from './../Utils';
const isIos = Platform.OS === "ios";
// import RazorpayCheckout from 'react-native-razorpay';
// import axios from 'axios';
// import firebase from 'react-native-firebase';
// import { NavigationEvents } from 'react-navigation';
// import OfflineHandler from './../OfflineHandler';
// import Toast, { DURATION } from 'react-native-easy-toast';

const logo = require('./../../assets/rectangle-logo.png')

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: "",
      numberValidate: true,
      error: false,
      props: this.props,
      theme: this.props.theme || null,
      visible: false,
      snackbarMsg: null,
      userInfo: null,
      showToast: false,
      toasterMessage: '',
      buttonDisable: false
    }
  }



  showToaster = (msg) => {
    this.setState({
      showToast: true,
      toasterMessage: msg
    })
  }


  

  clearAllDataAndLogout = () => {    
    // this.props.dispatchClearRegistation();  
  }

  async componentDidMount() {
    // firebaseLogEvent('login_screen', {})
    AsyncStorage.getItem('authKey', (err, res) => {
      // console.log(res)
      if (res) {
        // this.props.history.push('/Home')
        this.clearAllDataAndLogout();
      }
    })
  }


  componentWillUnmount() {
    // this.props.dispatchClearLoginInfo();
  }

  componentDidUpdate(prevProps) {
    if (this.props.err !== prevProps.err) {
      if (this.props.err) {
        this.showToaster(this.props.errInfo || 'some thing went wrong')
      }
    }

    if (this.props.status !== prevProps.status) {
      const toastMsg = typeof this.props.successInfo === 'string' ? this.props.successInfo : 'OTP successfully sent';

      if (this.props.status === 200) {
        if (this.props.status) {
          this.setState({
            buttonDisable: true
          })
          this.showToaster(toastMsg);
          setTimeout(() => {
            this.props.history.push(`/OtpScreen/${this.state.mobile}`);
            // this.setState({ mobile: '' , buttonDisable: false})
          }, 1000)
        }
      }
    }
 
  }


  // geolocation = async () => {
  //   try {
  //     const p = await PermissionsAndroid.request(
  //       PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION,
  //       {
  //         title: "Location Accessing Permission",
  //         message: "App needs access to your location"
  //       }
  //     );
  //     // alert(JSON.stringify(p));
  //     if (!p) return;
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const initialPosition = JSON.stringify(position);
  //         // alert(initialPosition);
  //         this.setState({ initialPosition });
  //       },
  //       // (error) => alert(error.message),
  //       { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 }
  //     );
  //   }
  //   catch (e) {
  //     // alert(JSON.stringify(e));
  //   }
  // }

  validatePhone = () => {
    Keyboard.dismiss();
    if (/^([0|\+[0-9]{1,5})?([6-9][0-9]{9})$/.test(this.state.mobile)) {
      // this.props.navigation.navigate('OtpScreen');
      this.setState({ error: false });
      this.props.login(this.state.mobile);
    } else {
      this.setState({
        error: true
      })
    }
  };

  share = () => {
    Share.share({
      title: '2thepoint',
      url: 'www.2thepoint.in',
      message: 'https://www.2thepoint.in'
    },
      {
        dialogTitle: 'share this page'
      })
  }
  render() {
    const { error, snackbarMsg } = this.state;
    const { err, errInfo, loading, response } = this.props;
    return (

      <div className='loginBox' style={{display: 'flex', justifyContent: 'center', alignItems: 'center',  position: 'relative', overflow: 'hidden' }}>
          <Container maxWidth='lg'>
         
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center', 
            zIndex: 100,
        
            }}
            >
                <BgCircle 
                size={30}
                style={{
                  bottom:-150,
                  left: 0,
                  zIndex: 0,
                  overflow: 'hidden'
                }}
                
                
              />
                <BgCircle 
                size={5}
                style={{
                  top:20,
                  left: '60%',
                  zIndex: 0,
                  overflow: 'hidden'
                }}
                
              />
               <View style={{ 
                flex: 1,
                // marginTop: -80 
               
                
                }}>            
                <View style={{ marginTop: -30,  marginBottom: 50, alignSelf: 'flex-start'}}>
                  <Text style={{ fontSize: 40, marginBottom: 0, fontWeight: '700', }}>
                    Sign in
                    </Text>
                </View>
              </View>

              {/* <View style={{ marginTop: 15,  width: '80%' }}>
                <Text style={{ color: 'red', alignSelf: 'flex-end', fontSize: 11, marginRight: '1%' }}>{error && "Enter valid mobile number"}</Text>
              </View> */}

              <View style={{ width: '100%', marginTop: 10, alignSelf: 'center',}}>
                {/* <Icon style={styles.searchIcon}
                  name={isIos ? "ios-phone-portrait" : "md-phone-portrait"}
                  size={30} /> */}
                <TextInput
                  mode="flat"
                  style={[styles.inputBox, {color: Styles.primaryColor, fontSize: 18, fontWeight: 'bold', letterSpacing: 4}]}
                  label='Mobile'
                  value={this.state.mobile}
                  isFocused={false}
                  keyboardType='numeric'
                  error={this.state.error}
                  onChangeText={mobile => {
                    if(mobile.length > 10 ) return null;
                    this.setState({ mobile })}
                  }
                  underlineColor={'#A4A4A4'}
                  maxLength={10}
                  theme={{ colors: { placeholder: '#A4A4A4', text: 'rgba(0,0,0,0.7)', primary: Styles.primaryColor, underlineColor: '#A4A4A4', } }}
                  onKeyPress={({nativeEvent: { key: keyValue }}) =>{
                    if(keyValue === 'Enter'){
                      this.validatePhone()
                    }
                  } }
               />

              </View>

              <View style={{ marginTop: 15, marginBottom: 15, }}>
                <Text style={{ color: '#455A64', fontSize: width >780  ? 18 : 14, textAlign: 'justify' }}>
                  We will send you an One Time Password to your registered mobile number
                {/* <Text
                    style={{ color: Styles.primaryColor, fontSize: 15, fontWeight: '500', cursor: 'pointer' }}
                    onPress={() => {
                      this.props.history.push('/Register')
                      this.setState({ mobile: '' });
                    }
                    }
                  // onPress={() => this.props.navigation.navigate('OtpScreen')}
                  > Sign Up
            </Text> */}
                </Text>
              </View>
              <View style={{ width: '70%',  marginBottom: 15, marginTop: 45, justifyContent: 'center', alignItems: 'centers' }}>
                <Button
                  onPress={() => this.validatePhone()}
                  mode="contained"
                  style={styles.button}
                  disabled={this.props.loading || this.state.buttonDisable ? true : false}
                  uppercase={false}
                  loading={this.props.loading  ? true : false}
                 
                >
                  <Text style={{ fontSize: 16, fontWeight: '600', color: '#000' }}> Get OTP</Text>
                </Button>
                <View style={{ marginTop: 25, marginBottom: 25, alignSelf: 'center' }}>
                <Text style={{ color: '#455A64' }}>
                  Don't have an account ?
                <Text
                    style={{ color: Styles.primaryColor, fontSize: 15, fontWeight: '500', cursor: 'pointer' }}
                    onPress={() => {
                      this.props.history.push('/Register')
                      this.setState({ mobile: '' });
                    }
                    }
                  // onPress={() => this.props.navigation.navigate('OtpScreen')}
                  > Sign Up
                </Text>
                </Text>
              </View>
              </View>
             
             <TouchableOpacity
               activeOpacity={0.9} 
               onPress={() => this.props.history.push('/LostPhone')}
             >
                <Text style={styles.forgetText}
                  
                >Lost Phone?</Text>
             </TouchableOpacity>
            
           
          </div>
          <div style={{position: 'relative', zIndex: 1000,justifyContent: 'center', alignSelf: 'center', flexDirection: 'row', display: 'flex', alignItems: 'center'}}>
            <h5 style={{textAlign :'center'}}>If there is any queries please do contact: </h5>
            <p style={{color: Styles.dangerColor, fontFamily: Styles.primaryFontFamily, marginLeft:10 }}>+91 9550435534</p> 
          </div>

            <Toaster 
              show={this.state.showToast}
              message={this.state.toasterMessage}
              handleClose={() => {
                this.setState({
                  showToast: false
                })
              }}
            />
        
        {/* <Toast
              position='bottom'
              positionValue={Colors.toastPositionValue}
              opacity={1}
              textStyle={{ color: Colors.toastTextColor }}
              style={{
                marginBottom: 50,
                backgroundColor: Colors.toastBgColor,
                paddingHorizontal: Colors.toastPaddingHorizontal,
                borderRadius: 20,
              }}
              ref="toast" /> */}
        </Container>      
      </div>
      
    )
  }
}

const styles = StyleSheet.create({
  statuBarColor: {
    // backgroundColor: Colors.statuBarColor,
  },
  splashBackgroundImage: {
    width: '100%',
    height: '100%',
  },
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
    width: 400,
    // height: deviceHeight
  },
  inputBox: {
    width: width >780 ? '50%' : '90%',
    backgroundColor: 'transparent',
    alignSelf: 'center'
  },

  button: {
    width: 200,
    borderRadius: 10,
    backgroundColor: '#f9c741',
    // borderRadius: 15,
    borderWidth: 2,
    borderColor: '#fff',
   height: 50, 
   justifyContent: 'center',
   alignItems:'center',
    alignSelf : 'center' 

  },
  fbBtnn: {
    width: '100%',
    backgroundColor: '#BF360C',
    marginVertical: 10,
  },
  buttonText: {
    fontSize: 14,
    color: '#fff',
    textAlign: 'center'
  },
  forgetText: {
    color: '#263238',
    fontSize: 16,
    fontWeight: '500',
    marginTop: 20,
    justifyContent: 'center',
    fontWeight: '600',
    color: '#000'
  },
  _bottomText: {
    marginTop: 'auto',
    color: '#fff',
    fontSize: 16,
    marginBottom: 10
  },
  get bottomText() {
    return this._bottomText;
  },
  set bottomText(value) {
    this._bottomText = value;
  },
  signupText: {
    fontSize: 16,
    marginLeft: 25,
    ...Platform.select({
      android: {
        color: '#fff',
        fontWeight: '700'
      },
      ios: {
        color: '#1a2b63',
      }
    })
  },
  error: {
    borderColor: '#fff',
    borderWidth: 1
  },
  searchSection: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10
  },
  searchIcon: {
    position: 'absolute',
    right: 15,
    top: 18,
    color: 'rgba(0,0,0,0.6)',
    // marginLeft: 15

  },
  SocialIcon: {
    flexDirection: 'row',
    width: 300,
    justifyContent: 'space-around',
    marginVertical: 25
  },
  facebookIcon: {
    flex: 1,
    borderRadius: 0,
    color: '#3C5A99'
  },
  googleIcon: {
    flex: 1,
    color: '#222'
  },
  ptfrm_text: {
    ...Platform.select({
      android: {
        paddingBottom: 5,
        color: '#fff'
      },
      ios: {
        paddingBottom: 5,
        color: '#fff'

      }
    })
  }
})

const mapStateToProps = state => ({
  loading: state.login && state.login.loading,
  response: state.login.response && state.login.response,
  status: state.login.response && state.login.response && state.login.response.status,
  successInfo: state.login.response && state.login.response.data && state.login.response.data.message && state.login.response.data.message,
  err: state.login && state.login.err,
  errInfo: state.login && state.login.errInfo && state.login.errInfo.response && state.login.errInfo.response.data && state.login.errInfo.response.data.message && state.login.errInfo.response.data.message
})

export default connect(mapStateToProps, { 
  login, dispatchClearLoginInfo, 

})(Login);

// export default Login
